const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginLeft: theme.spacing.unit * 2
  },
  modal: {
    minWidth: 300,
    maxWidth: minWidth / 1.5
  },
  flex: {
    flex: 1
  },
  submit: {
    color: "#fff"
  }
})

export default styles
